import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-cog-icon',
	templateUrl: './cog-icon.component.html',
})
export class CogIconComponent {
	@Input() public readonly variableName?: string = 'brandPrimary';

	constructor() {}
}
